import { pantryColors } from '@pantry/ui'

// Local visual constants for the extended (V2) Behavior tab, mirroring the
// design mockup `docs/pantry/2026.09.15/breadstack-customer-profile (6).html`.
// Uses `pantryColors` tokens where they exist; the success-green and delta hues
// below have no token (the shared palette's `green` is actually blue), so they
// live here as documented local constants rather than inline magic values.

export const C = pantryColors

// Success green used by the mockup's up-deltas / positive pills (`#16A34A`) —
// distinct from the token `brand.primary` (blue). No design token exists for it.
export const SUCCESS = '#16A34A'
export const SUCCESS_BG = '#F0FDF4'

// Mockup amber (`#F59E0B`) for the funnel's Started Checkout bar and the
// Orders Trend "Items" line — lighter than the `amber[700]` token.
export const WARNING = '#F59E0B'

// Delta chip colors. `up`/`down` are literal direction; `invDown` is a
// "good" downward move (e.g. cart abandonment falling), shown green.
export const DELTA = {
  up: SUCCESS,
  down: C.red[700],
  invUp: C.red[700],
  invDown: SUCCESS,
  flat: C.gray[400],
} as const

// `.b-pill-*` palette from the mockup.
export const PILL = {
  green: { bg: SUCCESS_BG, fg: SUCCESS },
  amber: { bg: C.amber[100], fg: C.amber[700] },
  red: { bg: C.red[50], fg: C.red[700] },
  blue: { bg: C.blue[50], fg: C.blue[700] },
  purple: { bg: C.purple[50], fg: C.purple[700] },
  gray: { bg: C.gray[100], fg: C.gray[500] },
} as const

export type PillTone = keyof typeof PILL
